module.exports = __webpack_public_path__ + "static/media/illu_no-result.ba1a5e8c.png";